<template>
  <div  class="bg-white fluid-container position-fixed-top border rounded shadow p-0 p-lg-1 col-md-12 col-lg-11 ">
    <h4>View and Edit Stream Information</h4>
        <div role="tablist">
        <b-card no-body class="mb-1" v-for="stream in streams" :key="stream.id">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle="'accordion-' + stream.id" :variant="stream.Active  ? 'success'  : 'secondary'" ><small> Resource: {{stream.Resource}},</small> {{stream.Title}} <small>{{stream.Description}}</small></b-button>
            </b-card-header>
            <b-collapse :id="'accordion-' + stream.id" accordion="my-accordion" role="tabpanel">
              <b-card-body class="p-0">
                <streamEdit v-if="show" :stream="stream" @refresh="refresh"></streamEdit>
              </b-card-body>
            </b-collapse>
          </b-card>   
        </div>
   <b-button v-on:click="cancel" variant="primary" class="ml-2">Close</b-button>
  </div>
</template>

<script>
import streamEdit from '../components/streamedit.vue'
/* eslint-disable */ 
  export default {
    name: "editStream",
    components: { 
        streamEdit
    },
    data() {
      return {
        streams: [],
        show: true,
      }
    },
    methods: {
    listStreams() {
        let currentObj = this;
        let params = new URLSearchParams();
        params.append('task', 'listStreams');
        this.axios.post('https://www.aperturefilms.com.au/customer-portal/admin.php', params)
                .then(function (response) {
                    //console.log(response.data)
                    currentObj.streams = response.data
                })
                .catch(function (error) {
                    console.log(error);  
                });
      },
      cancel(evt) {
          this.$emit('menuItem', false)
      },
      refresh() {

        this.show = false;
        this.listStreams();
        this.show = true;
      }

    },
    mounted() {
        this.listStreams()
    }
   
  }
</script>
<style scoped>
.fluid-container {
    margin:0 auto 0;
     margin-top: 110px;


}
</style>